import ng from "angular";
import { IdSvrAuthService } from "../../auth/idSrvAuthService";
import { AgGridService } from "@topline/services/agGridService";
import { DateService } from "@topline/services/dateService";
import { FileDownloadService } from "@topline/services/fileDownloadService";
import { MarketEditService } from "./services/marketEditService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { Gen } from "../../Services/api";
import { ToasterService } from "@topline/services/toasterService";
import { GridOptions } from "ag-grid-community";

class MarketInternationalEditController {
    static $inject = [
        "market",
        "editable",
        "countries",
        "currencies",
        "forecastConfiguration",
        "$scope",
        "$state",
        MarketEditService.componentName,
        IdSvrAuthService.componentName,
        angularServicesNames.$translate,
        ToasterService.componentName,
        FileDownloadService.componentName,
        AgGridService.componentName,
        "internationaMarketFileService",
        "modalService",
        DateService.componentName
    ];

    public forecastConfiguration: $TSFixMe;
    public canEdit: boolean;
    public canClone: boolean;
    public market: Gen.FileMarketDTO;
    public countries: Gen.CountryDTO[];
    public currencies: string[];
    public readOnly: boolean;
    public excludedProductCodes: string[];
    public loggedUserId: string;
    public skuHistoricalVolumeDataSources: Array<{ value: string; label: string }>;
    public historicalVolumeDataSources: Array<{ value: string; label: string }>;
    public productSearchActionsColumnTemplate: string;
    public productSearchCallbacks: {
        addProduct: (product: $TSFixMe) => void;
        addProducts: (products: $TSFixMe) => void;
        removeProduct: (rowNode: $TSFixMe) => void;
    };
    public productGridOptions: GridOptions;
    public actions: { save: () => void };
    public serverOperation: ng.IPromise<any>;
    public marketForm: ng.IFormController;
    public canEditImsIO: boolean;
    private gridApi: $TSFixMe;

    constructor(
        market: $TSFixMe,
        editable: $TSFixMe,
        countries: Gen.CountryDTO[],
        currencies: string[],
        forecastConfiguration: $TSFixMe,
        private $scope: ng.IScope,
        private $state: ng.ui.IStateService,
        private marketEditService: MarketEditService,
        private authService: IdSvrAuthService,
        private $translate: ng.translate.ITranslateService,
        private toasterService: ToasterService,
        private fileDownloadService: FileDownloadService,
        private agGridService: AgGridService,
        private internationaMarketFileService: $TSFixMe,
        private modalService: $TSFixMe,
        private dateService: DateService
    ) {
        this.forecastConfiguration = forecastConfiguration;
        this.canEdit = editable.isEditable == 1;
        this.canClone = editable.isCloneable == 1;
        this.market = market;
        this.countries = countries;
        this.currencies = currencies;
        this.readOnly = !this.market || !this.market.isCreatedByMy || !this.canEdit;
        this.excludedProductCodes = market.products.map((x: $TSFixMe) => x.productCode);
        authService.getCurrentUserLogin().then(login => (this.loggedUserId = login));
        authService.hasPermissionAsync("ManageImsIOMarkets").then(result => {
            this.canEditImsIO = result;
            this.historicalVolumeDataSources = this.getHistoricalVolumeDataSources();
        });

        this.$scope.$on("LanguageChanged", () => this.resetTranslations());

        if (this.canEdit && this.market && this.market.budgetYear == null) {
            this.market.budgetYear = this.dateService.getDefaultBudgetYear();
        }

        this.skuHistoricalVolumeDataSources = this.getSkuHistoricalVolumeDataSources();
        this.historicalVolumeDataSources = this.getHistoricalVolumeDataSources();

        this.setupProductCallbacks();
        this.setupProductGrid();
        this.setupActions();

        this.$scope.$watchCollection(
            "$ctrl.market.products",
            () => (this.excludedProductCodes = market.products.map((x: $TSFixMe) => x.productCode))
        );

        if (!this.canEdit && this.market.isCreatedByMy && this.canClone) {
            this.toasterService.warning("MARKET.READONLY_MODE");
        }
    }

    private resetTranslations(): void {
        this.skuHistoricalVolumeDataSources = this.getSkuHistoricalVolumeDataSources();
        this.historicalVolumeDataSources = this.getHistoricalVolumeDataSources();
    }

    private getSkuHistoricalVolumeDataSources(): Array<{ value: string; label: string }> {
        return [
            {
                value: "File",
                label: this.$translate.instant("MARKET.FILE")
            },
            {
                value: "Vmi",
                label: this.$translate.instant("MARKET.VMI")
            }
        ];
    }

    private getHistoricalVolumeDataSources(): Array<{ value: string; label: string }> {
        const options = [
            {
                value: "File",
                label: this.$translate.instant("MARKET.FILE")
            }
        ];

        if (this.canEditImsIO) options.push({ value: "ImsIO", label: this.$translate.instant("MARKET.IMS.LABEL") });

        return options;
    }

    public isFileDataSource(): boolean {
        return this.market.skuHistoricalVolumeDataSource == "File";
    }

    public isVMIDataSource(): boolean {
        return this.market.skuHistoricalVolumeDataSource == "Vmi";
    }

    public isNewMarket(): boolean {
        return !this.market || this.market.name == null;
    }

    public removeMarket(): void {
        if (!this.canEdit) {
            this.toasterService.warning("MARKET.READONLY_MODE");
            return;
        }

        this.modalService.showConfirmationModal(
            {
                text: "MARKET.REMOVE_CONFIRM",
                title: "MARKET.REMOVE_CONFIRM_TITLE"
            },
            () => {
                this.marketEditService
                    .delete(this.market.id)
                    .then(() => {
                        this.$state.go("market.list");
                        this.toasterService.success("MARKET.REMOVE_SUCCESS");
                    })
                    .catch(() => {
                        this.toasterService.error("MARKET.REMOVE_ERROR");
                    });
            },
            null,
            "danger"
        );
    }

    private isFilterEqual(f1: $TSFixMe, f2: $TSFixMe): boolean {
        return (
            f1.pharmacyMarket === f2.pharmacyMarket &&
            f1.perscirptionMarket === f1.perscirptionMarket &&
            f1.atc3 === f2.atc3 &&
            f1.atc4 === f2.atc4 &&
            _.isEqual(f1.nfc3, f2.nfc3) &&
            _.isEqual(f1.molecules, f2.molecules) &&
            f1.brand === f2.brand &&
            f1.moleculeType === f2.moleculeType &&
            f1.type === f2.type &&
            f1.sku === f2.sku &&
            f1.onlySelectedMolecues === f2.onlySelectedMolecues
        );
    }

    public addFilter = (filter: $TSFixMe): void => {
        var index = this.market.filters.findIndex((f: $TSFixMe) => this.isFilterEqual(filter, f));
        if (index < 0) {
            this.market.filters.push(angular.copy(filter));
        }
    };

    public removeFilter = (data: $TSFixMe): void => {
        var index = this.market.filters.findIndex((f: $TSFixMe) => this.isFilterEqual(data, f));
        if (index > -1) {
            this.market.filters.splice(index, 1);
        }
    };

    public countryChanged = (): void => {
        const country = _.find(this.countries, (c: Gen.CountryDTO) => c.code == this.market.countryCode);
        if (country) {
            this.market.currencyCode = country.currencyCode;
        }
    };

    private setupProductCallbacks(): void {
        this.productSearchActionsColumnTemplate = `<div class="ui-grid-cell-contents"><a href="#" ng-click="$ctrl.callbackScope.addProduct(data)"><i class="glyphicon glyphicon-plus"></i></a></div>`;

        this.productSearchCallbacks = {
            addProduct: (product: $TSFixMe) => {
                const existingProducts = this.market.products.map((p: $TSFixMe) => p.id);
                if (existingProducts.includes(product.id)) return;

                this.market.products.push(product);
                this.gridApi.setRowData(this.market.products);
                this.validateFiles();
            },
            addProducts: (products: $TSFixMe) => {
                const existingProducts = this.market.products.map((p: $TSFixMe) => p.id);
                for (const product of products) {
                    if (existingProducts.includes(product.id)) continue;
                    this.market.products.push(product);
                }
                this.gridApi.setRowData(this.market.products);
                this.validateFiles();
            },
            removeProduct: (rowNode: $TSFixMe) => {
                var index = this.market.products.findIndex((p: $TSFixMe) => p.productCode == rowNode.data.productCode);
                if (index >= 0) {
                    this.market.products.splice(index, 1);
                }
                this.gridApi.setRowData(this.market.products);
                this.validateFiles();
            }
        };
    }

    private setupProductGrid(): void {
        this.$scope.$on("LanguageChanged", () => this.agGridService.refreshGridLanguage(this.gridApi));

        this.productGridOptions = {
            columnDefs: [
                {
                    field: "productCode",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.ORACLE_INDEX"),
                    tooltipField: "productCode",
                    filter: "agTextColumnFilter",
                    filterParams: { newRowsAction: "keep" },
                    enableRowGroup: true
                },
                {
                    field: "sku",
                    tooltipField: "sku",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.SKU"),
                    filter: "agTextColumnFilter",
                    filterParams: { newRowsAction: "keep" },
                    enableRowGroup: true
                },
                {
                    field: "brand",
                    tooltipField: "brand",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.PRODUCT"),
                    filter: "agSetColumnFilter",
                    filterParams: { newRowsAction: "keep" },
                    enableRowGroup: true
                },
                {
                    field: "market",
                    tooltipField: "market",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.MARKET"),
                    filter: "agSetColumnFilter",
                    filterParams: { newRowsAction: "keep" },
                    enableRowGroup: true
                },
                {
                    field: "region",
                    tooltipField: "region",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.REGION"),
                    filter: "agSetColumnFilter",
                    filterParams: { newRowsAction: "keep" },
                    enableRowGroup: true
                },
                {
                    field: "businessUnit",
                    tooltipField: "businessUnit",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.BU"),
                    filter: "agSetColumnFilter",
                    filterParams: { newRowsAction: "keep" },
                    enableRowGroup: true
                },
                {
                    field: "line",
                    tooltipField: "line",
                    headerValueGetter: () =>
                        this.$translate.instant("ROLLING_FORECAST.PLANNER_PRODUCT_SEARCH_COMPONENT.LINE"),
                    filter: "agSetColumnFilter",
                    filterParams: { newRowsAction: "keep" },
                    enableRowGroup: true
                },
                {
                    headerValueGetter: () => this.$translate.instant("ACTIONS"),
                    hide: this.readOnly,
                    template: `<div class="ui-grid-cell-contents">
                            <a href="#" ng-click="$ctrl.productSearchCallbacks.removeProduct(rowNode)" title="{{'REMOVE' | translate}}"> <i class="glyphicon glyphicon-remove"></i></a>
                        </div>`
                }
            ],
            angularCompileRows: true,
            defaultColDef: {
                sortable: true,
                resizable: true
            },
            floatingFilter: true,
            animateRows: true,
            pagination: true,
            paginationPageSize: 10,
            rowGroupPanelShow: "always",
            domLayout: "autoHeight",
            suppressMultiSort: true,
            localeTextFunc: this.agGridService.transalteFunc,
            suppressDragLeaveHidesColumns: true,
            onGridReady: (config: $TSFixMe) => {
                this.gridApi = config.api;
                this.gridApi.setRowData(this.market.products);
                config.api.sizeColumnsToFit();
            },
            onGridSizeChanged: (config: $TSFixMe) => config.api.sizeColumnsToFit()
        };
    }

    public generateMarketTemplate = (): void => {
        if (!this.isMarketConfigurationValidForHistoricalVolume()) {
            this.toasterService.warning("MARKET.INVALID_MARKET_CONFIGURATION_FOR_HISTORICAL_VOLUME");
            return;
        }
        this.toasterService.showReportGenerateBusyIndicator(
            () =>
                this.fileDownloadService.downloadFilePost(
                    "/api/market/file/template/market-volume",
                    "MarketVolume.xlsx",
                    {
                        markets: [
                            {
                                marketId: this.market.id,
                                marketName: this.market.name,
                                historicalVolumeDataSource: this.market.historicalVolumeDataSource
                            }
                        ],
                        historicalDataStart: this.market.historicalDataStart,
                        historicalDataEnd: this.market.historicalDataEnd
                    }
                ),
            "MARKET.GENERATE_TEMPLATE",
            "MARKET.TEMPLATE_GENERATED"
        );
    };

    public generateSkuTemplate = (): void => {
        if (!this.isMarketConfigurationValidForSkuHistoricalVolume()) {
            this.toasterService.warning("MARKET.INVALID_MARKET_CONFIGURATION_FOR_SKU_HISTORICAL_VOLUME");
            return;
        }
        this.toasterService.showReportGenerateBusyIndicator(
            () =>
                this.fileDownloadService.downloadFilePost(
                    "/api/market/file/template/skus-volume",
                    "MarketSkusVolume.xlsx",
                    {
                        markets: [
                            {
                                marketId: this.market.id,
                                marketName: this.market.name,
                                skus: this.market.products,
                                skuHistoricalVolumeDataSource: this.market.skuHistoricalVolumeDataSource
                            }
                        ],
                        historicalDataStart: this.market.historicalDataStart,
                        historicalDataEnd: this.market.historicalDataEnd
                    }
                ),
            "MARKET.GENERATE_TEMPLATE",
            "MARKET.TEMPLATE_GENERATED"
        );
    };

    private isMarketConfigurationValidForHistoricalVolume() {
        const validations = {
            historicalDataDateRangesValid:
                this.market.historicalDataStart != null && this.market.historicalDataEnd != null,
            marketNameValid: this.market.name != null && this.market.name.trim() !== ""
        };

        return Object.values(validations).every(Boolean);
    }

    private isMarketConfigurationValidForSkuHistoricalVolume() {
        const validations = {
            historicalDataDateRangesValid:
                this.market.historicalDataStart != null && this.market.historicalDataEnd != null,
            marketNameValid: this.market.name != null && this.market.name.trim() !== "",
            countryCodeValid: this.market.countryCode != null && this.market.countryCode.trim() !== "",
            skusSelected: this.market.products.length > 0
        };

        return Object.values(validations).every(Boolean);
    }

    public uploadMarketFile = async (file: $TSFixMe) => {
        if (!this.isMarketConfigurationValidForHistoricalVolume()) {
            this.toasterService.warning("MARKET.INVALID_MARKET_CONFIGURATION_FOR_HISTORICAL_VOLUME");
            return;
        }

        if (!file) return;
        const market = {
            marketName: this.market.name,
            marketId: this.market.id
        };

        try {
            await this.internationaMarketFileService.uploadMarketFile({
                file,
                markets: [market],
                historicalDataStart: this.market.historicalDataStart,
                historicalDataEnd: this.market.historicalDataEnd
            });

            this.market.historicalVolumeExists = true;
            this.market.isHistoricalVolumeValid = true;
        } catch (e) { }
    };

    public uploadSkuFile = async (file: $TSFixMe): Promise<void> => {
        if (!this.isMarketConfigurationValidForSkuHistoricalVolume()) {
            this.toasterService.warning("MARKET.INVALID_MARKET_CONFIGURATION_FOR_SKU_HISTORICAL_VOLUME");
            return;
        }

        if (!file) return;
        const market = {
            marketName: this.market.name,
            marketId: this.market.id,
            skus: this.market.products
        };

        try {
            await this.internationaMarketFileService.uploadSkuFile({
                file,
                markets: [market],
                historicalDataStart: this.market.historicalDataStart,
                historicalDataEnd: this.market.historicalDataEnd
            });

            this.market.skuHistoricalVolumeExists = true;
            this.market.isSkuHistoricalVolumeValid = true;
        } catch (e) { }
    };

    public downloadFromVmi = (): void => {
        if (!this.isMarketConfigurationValidForSkuHistoricalVolume()) {
            this.toasterService.warning("MARKET.INVALID_MARKET_CONFIGURATION_FOR_SKU_HISTORICAL_VOLUME");
            return;
        }

        if (this.areSearchDataValid()) {
            let busyToast = this.toasterService.showReportGeneratingToast("MARKET.VALIDATING_PRODUCTS_VMI");
            this.internationaMarketFileService.validateVmiProducts(this.market).then((data: $TSFixMe) => {
                this.toasterService.clear(busyToast);
                if (data.hasErrors) {
                    this.toasterService.warning("MARKET.VMI_DATA_HAS_ERRORS");

                    let items = data.fieldsErrors
                        .map((e: $TSFixMe) => ({
                            field: e.path,
                            productCode: "",
                            error: e.resultType
                        }))
                        .concat(
                            data.productsErrors.map((e: $TSFixMe) => {
                                const p = e.path.split(".");
                                return {
                                    productCode: p[0],
                                    field: p.length > 1 ? p[1] : "",
                                    error: e.resultType
                                };
                            })
                        );
                    this.internationaMarketFileService.openFileValidationErrors(items);
                } else {
                    this.toasterService.success("MARKET.VALIDATED_PRODUCTS_VMI");
                }
            });
        } else {
            this.toasterService.warning("MARKET.FILE_ERRORS.TYPES.MissingData");
        }
    };

    private validateFiles(): void {
        if (this.isFileDataSource()) {
            this.internationaMarketFileService.validateFiles(this.market).then((data: $TSFixMe) => {
                if (!data.isProductsFileValid && this.market.skuHistoricalVolumeExists) {
                    this.toasterService.warning("MARKET.PRODUCT_FILE_HAS_ERRORS");
                }
            });
        } else {
            if (this.marketForm.$valid) {
                this.downloadFromVmi();
            }
        }
    }

    private areFilesValid(): boolean {
        return (
            this.market.isHistoricalVolumeValid &&
            this.market.historicalVolumeExists &&
            this.market.isSkuHistoricalVolumeValid &&
            (this.market.skuHistoricalVolumeExists || this.isVMIDataSource())
        );
    }

    private areSearchDataValid(): boolean {
        return (
            this.market.historicalDataStart != null &&
            this.market.historicalDataEnd != null &&
            this.market.products.length > 0 &&
            this.market.currencyCode != null
        );
    }

    private save(): void {
        this.serverOperation = this.marketEditService
            .saveFileMarket(this.market)
            .then(() => this.$state.go("market.list"));
    }

    private setupActions(): void {
        this.actions = {
            save: () => {
                if (!this.canEdit) return;
                if (this.marketForm.$valid) {
                    if (!this.areFilesValid()) {
                        this.modalService.showConfirmationModal("MARKET.FILE_MARKET_ERRORS_CONFIRMATION", () =>
                            this.save()
                        );
                    } else {
                        this.save();
                    }
                }
                this.marketForm.$submitted = true;
            }
        };
    }
}

// Register the controller with Angular
angular.module("topline.modules").controller("marketInternationalEditCtrl", MarketInternationalEditController);
